import { render, staticRenderFns } from "./start-list.vue?vue&type=template&id=6d9838dc&"
import script from "./start-list.vue?vue&type=script&lang=js&"
export * from "./start-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports